import {EventModelState, updateEventSolutionDetailsObject} from "src/state/slice/EventModelSlice";
import {TextArea} from "@amzn/stencil-react-components/form";
import React from "react";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {SolutionTypeNames, StringUtils} from "src/constant/constants";

interface IMessageBoardCmsIdInput {
    attributeName: string;
    attributeValue: string;
}

/**
 * This component is responsible for entering cms id for the message board
 * and also send updates to isRead context attributes for message board
 */
export const MessageBoardCmsIdInputComponent = ({attributeName, attributeValue}: IMessageBoardCmsIdInput) => {

    const replaceClientKeyIdentifierValue = (input: string, value: string): string => {
        const firstCommaIndex = input.indexOf(StringUtils.COMMA_SEPARATOR);
        const secondCommaIndex = input.indexOf(StringUtils.COMMA_SEPARATOR, firstCommaIndex + 1);

        if (firstCommaIndex === -1 || secondCommaIndex === -1) {
            return input;
        }

        const prefix = input.slice(0, firstCommaIndex + 1);
        const suffix = input.slice(secondCommaIndex);

        return `${prefix} ${value}${suffix}`;
    }

    const dispatch = useAppDispatch();
    const eventModelState: EventModelState = useAppSelector(({eventModel}) => eventModel);
    return <TextArea
        id={`${attributeName}-input`}
        resize={"both"}
        height={"45px"}
        minHeight={"45px"}
        width={"800px"}
        onChange={(e) => {
            let value: any = e?.target?.value;
            dispatch(updateEventSolutionDetailsObject({
                [attributeName]: value,
            }));
            dispatch(updateEventSolutionDetailsObject({
                [SolutionTypeNames.IS_READ]: replaceClientKeyIdentifierValue(eventModelState?.eventSolution?.solutionDetailObject[SolutionTypeNames.IS_READ], value)
            }))
        }}
        value={attributeValue}
    />
}
